import React, { useContext, useReducer, useMemo } from 'react';

import { formsReducer } from './helpers/reducers/forms';
import {
  useForgeUserMapping,
  useAllPgUsers,
  usePgUser,
  useAllFormTemplates,
} from './hooks';
import { PlangridLaunchDarklyProvider } from './PlangridLaunchDarklyProvider';

const FormsContext = React.createContext({});
const useFormsContext = () => useContext(FormsContext);

const FormsProvider = ({ children }) => {
  return (
    <PlangridLaunchDarklyProvider>
      <FormsProviderUnwrapped>{children}</FormsProviderUnwrapped>
    </PlangridLaunchDarklyProvider>
  );
};

const FormsProviderUnwrapped = ({ children }) => {
  const [state, dispatch] = useReducer(formsReducer, {
    newForm: {},
    newFormTemplate: {},
    templateCategories: [],
  });

  const { data: forgeUserMapping, isLoading: isLoadingForgeUserMapping } =
    useForgeUserMapping();
  const { data: pgProjectUsers, isLoading: isLoadingPgProjectUsers } =
    useAllPgUsers();
  const { data: formTemplates, isLoading: isLoadingFormTemplates } =
    useAllFormTemplates();
  const { data: pgProjectUser, isLoading: isLoadingPgProjectUser } =
    usePgUser();

  const value = useMemo(
    () => ({
      ...state,
      dispatch,
      forgeUserMapping: forgeUserMapping || {},
      pgProjectUser,
      pgProjectUsers: pgProjectUsers || [],
      formTemplates,
      isLoadingFormTemplates,
      isLoadingForgeUserMapping,
      isLoadingPgProjectUsers,
      isLoadingPgProjectUser,
    }),
    [
      state,
      forgeUserMapping,
      isLoadingForgeUserMapping,
      isLoadingPgProjectUsers,
      pgProjectUsers,
      formTemplates,
      isLoadingFormTemplates,
      pgProjectUser,
      isLoadingPgProjectUser,
    ],
  );

  return (
    <FormsContext.Provider value={value}>{children}</FormsContext.Provider>
  );
};

export { useFormsContext, FormsProvider };
